import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  SettingsSettingWeekendsBreadcrumb,
  basicDetail,
  editMode,
  statusDD,
  weekDays,
} from "../CreateSettingsSettingWeekends/constant";
import { Box, Container, Grid } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import EzControlledCheckBoxWithLabel from "../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { formatDatesHyphan } from "../../../../utils";

const CreateSettingsSettingWeekendsComponent = (props) => {
  const navigate = useNavigate();
  const {
    initCreateSettingsSettingWeekendsScreen,
    createSettingsSettingWeekends,
    editSettingsSettingWeekends,
    isSettingsSettingWeekendsCreateSuccess,
    isSettingsSettingWeekendsEditSuccess,
    isSettingsSettingWeekendsDetailSuccess,
    formFieldValueMap,
    shouldBlockNavigation,
    vehicleModelDD,
    isEdit,
  } = props;

  const classes = useStyles();
  const {
    control,
    formState: { errors, isDirty },
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => formFieldValueMap, [formFieldValueMap]),
  });

  const [weekDaysData, setWeekDaysData] = useState(weekDays);

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setWeekDaysData((prev) =>
      prev.map((item) =>
        item.name === name ? { ...item, isChecked: checked } : item
      )
    );
  };

  useEffect(() => {
    if (!isSettingsSettingWeekendsCreateSuccess && !isSettingsSettingWeekendsEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isSettingsSettingWeekendsCreateSuccess, isSettingsSettingWeekendsEditSuccess]);

  const navigateToSettingsSettingWeekendsScreen = () => {
    navigate(APP_URLS.SETTINGS_SETTINGWEEKENDS.HOME);
  };

  useEffect(() => {
    if (
      isSettingsSettingWeekendsCreateSuccess ||
      isSettingsSettingWeekendsEditSuccess
    ) {
      reset();
    }
  }, [
    isSettingsSettingWeekendsCreateSuccess,
    isSettingsSettingWeekendsEditSuccess,
  ]);

  useEffect(() => {
    if (isSettingsSettingWeekendsDetailSuccess) {
      reset({ ...formFieldValueMap });
      const weekendDaysArray = formFieldValueMap?.weekendDays
        ?.split(",")
        .map(Number);
      setWeekDaysData((prev) =>
        prev.map((item) => ({
          ...item,
          isChecked: weekendDaysArray.includes(item.value),
        }))
      );
    }
  }, [isSettingsSettingWeekendsDetailSuccess]);

  useEffect(() => {
    initCreateSettingsSettingWeekendsScreen();
  }, []);

  const onSubmit = (data) => {
    const selectedDays = weekDaysData
      .filter((d) => d.isChecked)
      .map((d) => d.value);
    const payload = {
      ...data,
      startDate: formatDatesHyphan(data.startDate),
      endDate: formatDatesHyphan(data.endDate),
      weekendDays: selectedDays.toString(),
      userId: localStorage.getItem("userId"),
    };

    isEdit
      ? editSettingsSettingWeekends({ id: data.id, data: payload })
      : createSettingsSettingWeekends(payload);
  };

  const getFormErrorMessage = (name) =>
    errors[name] && <small className="p-error">{errors[name].message}</small>;

  const renderPageHeaderSection = () => (
    <div className="make-relative sub-header">
      <div className="maintitlediv">
        <h4 className="pagetitle">
          {isEdit ? "Update Setting Weekends" : "Create Setting Weekends"}
        </h4>
        <div className="buttonarea">
          <Button
            label="Back to Setting Weekends"
            className="p-button"
            style={{ borderRadius: "10px" }}
            onClick={navigateToSettingsSettingWeekendsScreen}
          />
        </div>
      </div>
    </div>
  );

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={SettingsSettingWeekendsBreadcrumb} />
      <EzToast
        severity={TOAST_SEVERITY.ERROR}
        toastTitle="Please select category"
        shouldShowToast={false}
      />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo ">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2}>
              {basicDetail?.map((item) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                  {item.type === "date" ? (
                    <EzControlledCalendarWithFloatingLabel
                      id={item.name}
                      name={item.name}
                      control={control}
                      maxDate={new Date(2090, 0, 1)}
                      dateFormat="yy/mm/dd"
                      label={item.label}
                      isError={errors[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                    />
                  ) : item.name === "status" ? (
                    <EzControlledDropDowntWithFloatingLabel
                      name={item.name}
                      control={control}
                      label={item.label}
                      options={statusDD}
                      optionLabel="name"
                      optionValue="id"
                      isError={errors[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                    />
                  ) : (
                    <EzControlledInputWithFloatingLabel
                      name={item.name}
                      control={control}
                      label={item.label}
                      type={item.type}
                      isError={errors[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                    />
                  )}
                </Grid>
              ))}
            </Grid>

            <Grid container spacing={2} >
              {weekDaysData.map((item) => (
                <Grid item xs={6} sm={4} md={3} key={item.name}>
                  <EzControlledCheckBoxWithLabel
                    name={item.name}
                    value={item.isChecked}
                    label={item.label}
                    control={control}
                    onChange={handleCheckbox}
                    labelClassName="ml-2"
                  />
                </Grid>
              ))}
            </Grid>

            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>

            {isEdit && (
              <Grid className="modsection" container spacing={2} sx={{ mt: 2 }}>
                {editMode?.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item.name}
                      control={control}
                      label={item.label}
                      disabled={item.disabled}
                      type={item.type}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateSettingsSettingWeekendsComponent;
